import { Component, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { IGridFilterNumeric } from '../../interface/grid-filter';
import { GridFilterBase } from '../grid-filter-base';

@Component({
  standalone: false,
  selector: 'mf-grid-filter-numeric',
  templateUrl: './grid-filter-numeric.component.html',
  styleUrls: ['./grid-filter-numeric.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => GridFilterNumericComponent),
      multi: true,
    },
  ],
})
export class GridFilterNumericComponent extends GridFilterBase<IGridFilterNumeric, number | null> {}
